/*
 * Die Anwendertexte des Abschnitts „Ansprechpartner“ an Angebot und Auftrag (Spec 2026-11-04-ansprechpartner-paare,
 * Hausregel „Texte in Properties“): Schlüssel englisch, Werte deutsch.
 */
const SEP = " · ";
type Pair = { haupt: string | null; stellv: string | null };
const side = (p: Pair): string => `${p.haupt ?? "—"}${p.stellv === null ? "" : `, Stellvertretung ${p.stellv}`}`;

export const REPRESENTATIVE_UI_TEXT = {
  section: "Ansprechpartner",
  loading: "Lädt …",
  loadFailed: "Die Ansprechpartner konnten nicht geladen werden.",
  saveFailed: "Die Ansprechpartner konnten nicht gespeichert werden.",
  conflict: "Dieser Vorgang wurde zwischenzeitlich geändert. Der aktuelle Stand ist neu geladen — bitte erneut ausführen.",
  empty: "Noch keine Ansprechpartner. Über „Bereich hinzufügen“ kommen je Bereich die Personen beider Seiten in den Beleg.",
  emptyReadOnly: "Dieser Vorgang führt keine Ansprechpartner.",
  frozen: "Der Vorgang ist gesendet bzw. beendet — seine Ansprechpartner lassen sich nicht mehr ändern.",
  add: "Bereich hinzufügen",
  titleNew: "Ansprechpartner hinzufügen",
  titleEdit: (bereich: string): string => `Ansprechpartner ${bereich} bearbeiten`,
  edit: (bereich: string): string => `Ansprechpartner ${bereich} bearbeiten`,
  actions: (bereich: string): string => `Aktionen zu Ansprechpartner ${bereich}`,
  remove: "Entfernen",
  category: "Bereich",
  categoryChoose: "Bitte wählen …",
  contractor: "Auftragnehmer",
  client: "Auftraggeber",
  primary: "Hauptperson",
  deputy: "Stellvertretung",
  nobody: "— niemand —",
  save: "Speichern",
  /** Der Rückfrage-Satz vor dem Speichern (Hausregel „Bestätigung vor Datenänderung“). */
  confirmSaveTitle: "Ansprechpartner speichern?",
  confirmSaveText: (bereich: string): string =>
    `Die Ansprechpartner für „${bereich}“ werden am Vorgang gespeichert und erscheinen im Beleg.`,
  confirmRemoveTitle: "Ansprechpartner entfernen?",
  confirmRemoveText: (bereich: string): string =>
    `„${bereich}“ mit allen Personen aus diesem Vorgang entfernen? Nutzer und Kontakte selbst bleiben erhalten.`,
  /** „Auftragnehmer: Dirk Heinze, Stellvertretung Wulsch · Auftraggeber: —“ */
  pairSummary: (an: Pair, ag: Pair): string => `Auftragnehmer: ${side(an)}${SEP}Auftraggeber: ${side(ag)}`,
} as const;
